import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import "./list.scss"
import Lifestyle from "../../components/patient-timeline/lifestyle"

const LifestyleContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <Lifestyle />
      </div>
    </div>
  )
}

export default LifestyleContainer